






























import { Component, Mixins } from 'vue-property-decorator';
import SmsPointMixin from './mixins/smsPointMixin';

@Component
export default class SmsPointSummary extends Mixins(SmsPointMixin) {}
